<template>
  <v-container fluid>
    <h1 class="heading">Download de app!</h1>
    <h2>Voor de iPhone of iPad</h2>
    <a href="https://apps.apple.com/nl/app/75-jaar-bevrijding-ommen/id1506650489?mt=8">
      <img src="@/assets/download-appstore.svg" width="120" />
      <span class="sr-only">Download voor iPhone of iPad in de app store</span>
    </a>
    <br/>
    <h2>Ontdek het op Google Play</h2>
    <a href="https://play.google.com/store/apps/details?id=nl.nosmallthing.ommen75jaarbevrijding">
        <v-img src="@/assets/google-play-badge.png" width="140" />
        <span class="sr-only">Ontdek het op Google Play</span>
      </a>
  </v-container>
</template>

<script>
export default {
  metaInfo: {
    title: 'Download de app'
  },
}
</script>

<style scoped>
.heading {
  margin-bottom: 30px;
}
</style>
